import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';
import { personalBeautyStoreContext } from "./personalBeautyStoreContext";
import { useCookieStoreInfo } from "./useCookieStoreInfo";
import { useInviteFriendData } from "./useInviteFriendData";
import { usePersonalBeautyStoreData } from "./usePersonalBeautyStoreData";
import { useWasTooltipShown } from "../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
export var PersonalBeautyStoreProvider = function PersonalBeautyStoreProvider(_ref) {
  var children = _ref.children;
  var storeInfo = useCookieStoreInfo();
  var pbsData = usePersonalBeautyStoreData();
  var inviteFriendData = useInviteFriendData();
  var _useWasTooltipShown = useWasTooltipShown(),
    _useWasTooltipShown2 = _slicedToArray(_useWasTooltipShown, 2),
    tooltipWasShown = _useWasTooltipShown2[0],
    setTooltipWasShown = _useWasTooltipShown2[1];
  var value = useMemo(function () {
    return {
      pbsData: pbsData,
      storeInfo: storeInfo,
      inviteFriendData: inviteFriendData,
      tooltipWasShown: tooltipWasShown,
      setTooltipWasShown: setTooltipWasShown
    };
  }, [pbsData, storeInfo, inviteFriendData, tooltipWasShown, setTooltipWasShown]);
  return /*#__PURE__*/_jsx(personalBeautyStoreContext.Provider, {
    value: value,
    children: children
  });
};